var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { UserRole, UserStatus } from '@logz-pkg/enums';
export const humanReadableRoles = {
    [UserRole.Siem]: 'Siem',
    [UserRole.ReadOnly]: 'Read Only',
    [UserRole.User]: 'User',
    [UserRole.Admin]: 'Admin',
    [UserRole.Expert]: 'Expert User',
    null: 'Configured per user',
};
export class BaseUserModel {
    username = '';
    fullName = '';
    role = UserRole.User;
    accountID;
}
export class UserModel extends BaseUserModel {
    id;
    username = '';
    fullName = '';
    role = UserRole.User;
    status = UserStatus.Pending;
    accountId;
    isActive;
    getHumanReadableRole() {
        return humanReadableRoles[this.role];
    }
    getDomain() {
        this.username.substr(this.username.indexOf('@') + 1).toLowerCase();
    }
}
__decorate([
    Expose({ name: 'accountID' }),
    __metadata("design:type", Number)
], UserModel.prototype, "accountId", void 0);
__decorate([
    Expose({ name: 'active' }),
    __metadata("design:type", Boolean)
], UserModel.prototype, "isActive", void 0);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModel.prototype, "getHumanReadableRole", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserModel.prototype, "getDomain", null);
//# sourceMappingURL=user.js.map